import { useEffect } from "react";

export default function AuthSuccess() {

  useEffect(() => {

    const token =
      new URLSearchParams(
        window.location.search
      ).get("token");

    if (token) {

      localStorage.setItem(
        "ldc_token",
        token
      );

      window.location.href =
        "/dashboard";
    }

  }, []);

  return <div>Logging in...</div>;
}
